import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-co2-legend',
  templateUrl: './co2-legend.component.html',
  styleUrls: ['./co2-legend.component.scss']
})
export class Co2LegendComponent implements OnInit {

  @Input() class: string = 'ms-2 text-18';

  constructor() { }

  ngOnInit(): void {
  }

}
